import React, { Component } from 'react'
import { Button, CardActions } from 'react-md'
import { reduxForm } from 'redux-form'

class ViewHeader extends Component {
  render () {
    const { onRefreshSales } = this.props

    return (
      <div className='export-sales-header'>

        <CardActions className='view-actions view-actions--right'>
          <Button flat iconChildren='refresh' onClick={onRefreshSales}>
            Refresh All Sales
          </Button>
        </CardActions>

      </div>
    )
  }
}

export default reduxForm({
  form: 'user-details',
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  pure: false
})(ViewHeader)



// WEBPACK FOOTER //
// ./src/containers/ExportSales/ViewHeader/index.js